// src/app/ClientLayout.tsx
'use client';

import ThemeProvider from '@/shared/providers/ThemeProvider';

export default function ClientLayout({ children, toast, initialTheme }: { children: React.ReactNode; toast: React.ReactNode; initialTheme: 'light' | 'dark' }) {
  return (
    <ThemeProvider initialTheme={initialTheme}>
      {toast}
      {children}
    </ThemeProvider>
  );
}
